import {client} from './services/client'

export  const types = {
    namespaced:true,
    state:{
        types:[],
    },
    mutations: {
        SET_TYPE (state,types){
            state.types = types
        },

    },
    actions: {
        getType({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/tiers/type/get',
                })
                    .then((response)=>{
                        let types = response.data.types;
                        console.log(types);
                        commit('SET_TYPE',types)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        setType({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/tiers/type/save',
                    data:data,
                })
                    .then((response)=>{
                        let types = response.data.types;
                        commit('SET_TYPE',types);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteType({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/tiers/type/delete/'+id,
                })
                    .then((response)=>{
                        let types = response.data.types;
                        commit('SET_TYPE',types);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getType: state  => {
            return state.types
        },
    }
};
